export default __webpack_public_path__ + "static/media/positive-vote.f5bc4c22.png";